import { Injectable } from '@angular/core';
import * as braze from '@braze/web-sdk';
import { pipe, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BrazeEventsService {
  readonly USER_DETAILS_CLOSED = 'user_details_closed';
  readonly CHANGED_ACCOUNT_SETTINGS = 'changed_account_settings';
  readonly CLICKED_HELP_ICON = 'clicked_help_icon';
  readonly CLICKED_WEBTOOLS_MENU = 'clicked_webtools_menu';
  readonly EXPORTED_USERS = 'exported_users';
  readonly OPENED_FRESHCHAT = 'opened_freshchat';
  readonly USERS_TABLE_ADDED_NEW_USER = 'users_table_added_new_user';
  readonly USERS_TABLE_BULK_ASSIGNED_PRODUCTS =
    'users_table_bulk_assigned_products';
  readonly USERS_TABLE_BULK_DELETED_USERS = 'users_table_bulk_deleted_users';
  readonly USERS_TABLE_BULK_INVITED_USERS = 'users_table_bulk_invited_users';
  readonly USERS_TABLE_BULK_UNASSIGNED_PRODUCTS =
    'users_table_bulk_unassigned_products';
  readonly USERS_TABLE_SEARCHED_ASSET = 'users_table_searched_asset';
  readonly USERS_INVITED_AFTER_CREATION_EMAIL =
    'users_invited_after_creation_email';
  readonly USERS_TABLE_SELECTED_VIEW = 'users_table_selected_view';
  readonly USERS_TABLE_SENT_INVITE = 'users_table_sent_invite';
  readonly USED_SMS_INVITE = 'used_sms_invite';
  readonly USED_ASSETS_TABLE_FILTER = 'used_assets_table_filter';
  readonly IMPORTED_ASSETS = 'imported_assets';
  readonly SET_PASSWORD_FOR_ASSET = 'set_password_for_asset';
  readonly SET_PASSWORD_FOR_ASSETS_BULK = 'set_password_for_assets_bulk';
  readonly SWITCHED_ACCOUNT = 'switched_account';
  readonly LOADED_USER_DETAILS = 'loaded_user_details';
  readonly USER_DETAILS_DELETED_USER = 'user_details_deleted_user';
  readonly USER_DETAILS_SAVED = 'user_details_saved';
  readonly LOADED_CONFIGURE_FLEET_PAGE = 'loaded_configure_fleet_page';
  readonly LOADED_DIAGNOSTICS_PAGE = 'loaded_diagnostics_page';
  readonly LOADED_MANAGE_ACCOUNT_PAGE = 'loaded_manage_account_page';
  readonly LOADED_USER_ACCESS_PAGE = 'loaded_user_access_page';
  readonly LOADED_ASSETS_PAGE = 'loaded_assets_page';
  readonly CLICKED_EXPIRED_APP_CONTENT_TOOLS =
    'clicked_expired_app_Content_Tools';
  readonly CLICKED_EXPIRED_APP_MAPSURE = 'clicked_expired_app_MapSure';
  readonly CLICKED_EXPIRED_APP_PC_MILER_WEB =
    'clicked_expired_app_PC*MILER_Web';
  readonly CLICKED_EXPIRED_APP_MAPEXACT = 'clicked_expired_app_MapExact';
  readonly CLICKED_EXPIRED_APP_ROUTEREPORTER =
    'clicked_expired_app_RouteReporter';
  readonly CLICKED_UNLICENSED_APP_CONTENT_TOOLS =
    'clicked_unlicensed_app_Content_Tools';
  readonly CLICKED_UNLICENSED_APP_MAPEXACT = 'clicked_unlicensed_app_MapExact';
  readonly CLICKED_UNLICENSED_APP_MAPSURE = 'clicked_unlicensed_app_MapSure';
  readonly CLICKED_UNLICENSED_APP_PC_MILER_WEB =
    'clicked_unlicensed_app_PC*MILER_Web';
  readonly CLICKED_UNLICENSED_APP_ROUTEREPORTER =
    'clicked_unlicensed_app_RouteReporter';
  readonly WEBTOOLS_MENU_NAVIGATED_TO_CONTENT_TOOLS =
    'webtools_menu_navigated_to_Content_Tools';
  readonly WEBTOOLS_MENU_NAVIGATED_TO_MAPEXACT =
    'webtools_menu_navigated_to_MapExact';
  readonly WEBTOOLS_MENU_NAVIGATED_TO_MAPSURE =
    'webtools_menu_navigated_to_MapSure';
  readonly WEBTOOLS_MENU_NAVIGATED_TO_PC_MILER_WEB =
    'webtools_menu_navigated_to_PC*MILER_Web';
  readonly WEBTOOLS_MENU_NAVIGATED_TO_ROUTEREPORTER =
    'webtools_menu_navigated_to_RouteReporter';
  readonly CREATED_VEHICLE_GROUP = 'create_vehicle_group';
  readonly CREATED_ALL_VEHICLES_GROUP = 'created_all_vehicles_group';
  readonly READ_VEHICLE_GROUP = 'read_vehicle_group';
  readonly UPDATED_VEHICLE_GROUP = 'update_vehicle_group';
  readonly DELETE_VEHICLE_GROUP = 'delete_vehicle_group';
  readonly SEARCH_FOR_VEHICLE_GROUP = 'search_for_vehicle_group';
  readonly CREATED_VEHICLE_ROUTING_PROFILE = 'create_vrp';
  readonly READ_VEHICLE_ROUTING_PROFILE = 'read_vehicle_routing_profile';
  readonly UPDATED_VEHICLE_ROUTING_PROFILE = 'update_vrp';
  readonly DELETE_VEHICLE_ROUTING_PROFILE = 'delete_vrp';
  readonly SEARCH_FOR_VEHICLE_ROUTING_PROFILE = 'search_for_vrp';
  readonly CREATED_CONFIGURATION_PROFILE = 'create_configuration_profile';
  readonly READ_CONFIGURATION_PROFILE = 'read_configuration_profile';
  readonly UPDATED_CONFIGURATION_PROFILE = 'update_configuration_profile';
  readonly DELETE_CONFIGURATION_PROFILE = 'delete_configuration_profile';
  readonly SEARCH_FOR_CONFIGURATION_PROFILE =
    'search_for_configuration_profile';
  readonly CREATED_MAPSET = 'create_mapset';
  readonly READ_MAPSET = 'read_mapset';
  readonly UPDATED_MAPSET = 'update_mapsets';
  readonly DELETE_MAPSETS = 'delete_mapsets';
  readonly SEARCH_FOR_MAPSETS = 'search_for_mapsets';
  readonly SEARCH_FOR_ROUTE_MODIFIERS = 'search_for_route_modifiers';
  readonly SEARCH_FOR_CUSTOM_PLACES = 'search_for_custom_places';
  readonly CLICKED_CONTENT_TOOL_FROM_ROUTE_MODIFIERS =
    'clicks_to_CT_from_route_modifiers';
  readonly CLICKED_CONTENT_TOOL_FROM_CUSTOM_PLACES =
    'clicks_to_CT_from_custom_places';
  readonly CREATED_VEHICLE = 'created_vehicle';
  readonly READ_VEHICLE = 'read_vehicle';
  readonly UPDATED_VEHICLE = 'updated_vehicle';
  readonly DELETE_VEHICLE = 'delete_vehicle';
  readonly EXPORTED_VEHICLE = 'exported_vehicle';
  readonly IMPORT_VEHICLES = 'import_vehicles';
  readonly CREATED_DRIVER = 'created_driver';
  readonly READ_DRIVER = 'read_driver';
  readonly UPDATED_DRIVER = 'update_driver';
  readonly DELETE_DRIVER = 'delete_driver';
  readonly EXPORTED_DRIVER = 'export_drivers';
  readonly IMPORT_DRIVERS = 'import_drivers';
  readonly CLICKED_VEHICLES_HELP_BUTTON = 'clicked_vehicles_help_button';
  readonly CLICKED_VEHICLE_GROUPS_HELP_BUTTON =
    'clicked_vehicle_groups_help_button';
  readonly CLICKED_ROUTING_PROFILES_HELP_BUTTON =
    'clicked_routing_profiles_help_button';
  readonly CLICKED_CONFIG_PROFILES_HELP_BUTTON =
    'clicked_config_profiles_help_button';
  readonly CLICKED_MAP_SETS_HELP_BUTTON = 'clicked_map_sets_help_button';
  readonly CLICKED_ROUTE_MODIFIERS_HELP_BUTTON =
    'clicked_route_modifiers_help_button';
  readonly CLICKED_CUSTOM_PLACES_HELP_BUTTON =
    'clicked_custom_places_help_button';
  readonly CLICKED_DRIVERS_HELP_BUTTON = 'clicked_drivers_help_button';
  readonly CLICKED_DRIVER_GROUPS_HELP_BUTTON =
    'clicked_driver_groups_help_button';
  readonly CLICKED_ASSETS_HELP_BUTTON = 'clicked_assets_help_button';
  readonly CLICKED_MAP_UPDATES_HELP_BUTTON = 'clicked_map_updates_help_button';
  readonly LOADED_CFS_VEHICLES = 'loaded_cfs_vehicles';
  readonly LOADED_CFS_VEHICLE_GROUPS = 'loaded_cfs_vehicle_groups';
  readonly LOADED_CFS_VEHICLE_ROUTING_PROFILES =
    'loaded_cfs_vehicle_routing_profiles';
  readonly LOADED_CFS_CONFIGURATION_PROFILES =
    'loaded_cfs_configuration_profiles';
  readonly LOADED_CFS_MAP_SETS = 'loaded_cfs_map_sets';
  readonly LOADED_CFS_MAP_UPDATES = 'loaded_cfs_map_updates';
  readonly LOADED_CFS_ROUTE_MODIFIERS = 'loaded_cfs_route_modifiers';
  readonly LOADED_CFS_CUSTOM_PLACES = 'loaded_cfs_custom_places';
  readonly LOADED_CFS_DRIVERS = 'loaded_cfs_drivers';
  readonly LOADED_CFS_DRIVER_GROUPS = 'loaded_cfs_driver_groups';
  readonly LOADED_CFS_FLEET_PREFERENCES = 'loaded_cfs_fleet_preferences';
  readonly LOADED_DASHBOARD = 'loaded_dashboard';
  readonly LOADED_WEATHER_CONFIGURATION = 'loaded_weather_configuration';
  readonly CHANGED_ASSET_DEFAULTS_AUTOMATIC_SEND =
    'changed_asset_defaults_automatic_send';
  readonly CHANGED_ASSET_DEFAULTS_MESSAGE_TYPE =
    'changed_asset_defaults_message_type';
  readonly CHANGED_ASSET_DEFAULTS_COUNTRY_CODE =
    'changed_asset_defaults_country_code';
  readonly CHANGED_ASSET_DEFAULTS_LANGUAGE = 'changed_asset_defaults_language';
  readonly OPENED_ASSETS_MAP = 'opened_assets_map';
  readonly CLICKED_BULK_ASSETS_NOTIFY_USERS_BUTTON =
    'clicked_bulk_assets_notify_users_button';
  readonly CLICKED_EDIT_ASSETS_NOTIFY_USERS_BUTTON =
    'clicked_edit_assets_notify_users_button';
  readonly CLICKED_VIEW_ROUTE_MODIFIERS_IN_CONTENTTOOLS =
    'clicked_view_route_modifiers_in_contenttools';
  readonly CLICKED_VIEW_CUSTOM_PLACES_IN_CONTENTTOOLS =
    'clicked_view_custom_places_in_contenttools';
  readonly VIEW_LICENSES = 'view_licenses';
  readonly VIEW_FLEET_LICENSES = 'view_fleet_licenses';
  readonly LOADED_REPORTING_PAGE = 'loaded_reporting_page';
  readonly DASHBOARD_CTA_ASSETS_ASSIGNED_NOT_ACTIVATED =
    'dashboard_cta_assets_assigned_not_activated';
  readonly DASHBOARD_CTA_ASSETS_UNASSIGNED_NOT_ASSIGNED =
    'dashboard_cta_assets_unassigned_not_assigned';
  readonly DASHBOARD_CONTENTTOOLS_INFORMATION_REQUESTED =
    'dashboard_contenttools_information_requested';
  readonly DASHBOARD_CONTENTTOOLS_GET_IT_CLICK =
    'dashboard_contenttools_get_it_click';
  readonly CLICKED_ROUTEREPORTER_INTEREST_CTA =
    'clicked_routereporter_interest_cta';
  readonly DARK_MODE_ACTIVATED = 'dark_mode_activated';
  readonly LIGHT_MODE_ACTIVATED = 'light_mode_activated';

  logBrazeCustomEvents(eventName: string) {
    braze.logCustomEvent(eventName);
  }

  trackSearchBrazeEvent(brazeEvent: string) {
    let logSearchValueFlag = true;
    return pipe(
      tap<string>((searchValue: string) => {
        if (
          typeof searchValue === 'string' &&
          searchValue.length === 1 &&
          logSearchValueFlag
        ) {
          logSearchValueFlag = false;
          this.logBrazeCustomEvents(brazeEvent);
        } else if (typeof searchValue === 'string' && searchValue === '') {
          logSearchValueFlag = true;
        }
      })
    );
  }
}
